import { Link } from 'react-router-dom';
import { comicCategories } from '@/mocks/comics';

export default function CategoryGrid() {
  return (
    <section className="mx-auto max-w-[1280px] px-4 py-12 md:px-8">
      <div className="mb-6 flex items-end justify-between">
        <div>
          <h2 className="font-heading text-2xl text-foreground-950">漫画分类</h2>
          <p className="mt-1 text-sm text-foreground-500">按照你喜欢的题材，快速找到心仪漫画</p>
        </div>
        <Link to="/list" className="hidden items-center gap-1 text-sm text-secondary-600 transition hover:text-secondary-700 sm:flex">
          全部分类
          <i className="ri-arrow-right-s-line" />
        </Link>
      </div>

      <div className="grid grid-cols-2 gap-3 sm:grid-cols-3 md:grid-cols-5">
        {comicCategories.map((category) => (
          <Link
            key={category.id}
            to={`/category/${category.id}`}
            className="group flex items-center gap-3 rounded-lg border border-background-200 bg-background-50 p-3 transition hover:border-primary-300 hover:bg-primary-50"
          >
            <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-accent-100 text-xl text-accent-700 transition group-hover:bg-accent-500 group-hover:text-foreground-950">
              <i className={category.icon} />
            </span>
            <span className="min-w-0">
              <span className="block truncate text-sm font-medium text-foreground-900">{category.name}</span>
              <span className="block truncate text-xs text-foreground-500">精选好漫</span>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}